/**
 * CreateStore queries
 */
import gql from 'graphql-tag'

export const getInlineCoresQuery = gql`
  query getInlineCores(
    $limit: Int
    $offset: Int
  ) {
    coreResults: inlineCoreItems(
      limit: $limit
      offset: $offset
    ) {
      fullCount
      products {
        id
        code
        active
        yotpoId: yotpo_id
        name
        weight
        discontinued
        onlyProDesign: only_pro_design
        description: short_description
        priceRange {
          quantity
          price
          abbreviation
          shortName: short_name
        }
        pictures: original_pictures {
          front: front_image
          preview
          default_preview
          thumbnail
        }
        colors {
          id
          name
          image
        }
        genders {
          id
          name: gender
        }
      }
    }
  }
`

export const getAllInlineCoresQuery = gql`
  query getAllInlineCores {
    coreResults: allInlineCores {
      id
      code
      active
      yotpoId: yotpo_id
      type: name
      weight
      discontinued
      description: short_description
      priceRange {
        quantity
        price
        abbreviation
        shortName: short_name
      }
      colors {
        id
        name
        image
      }
      pictures: original_pictures {
        front: front_image
        thumbnail
        preview
        default_preview
      }
      genders {
        id
        name: gender
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/InlineModal/data.ts